import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Username', value: 'username', width: '300' },
  { text: 'MID', value: 'mid' },
  { text: 'Last Login', value: 'last_login_at' },
  { text: 'Created Date', value: 'created_at' },
  { text: 'Force Change Password', value: 'password_change_name', align: 'center', textAlign: 'text-center' },
  { text: 'Status', value: 'custom_status', align: 'center', textAlign: 'text-center' },
  { text: 'Action', value: 'action', width: '150'  },
]);

export const search =  {
  username: '',
  mid: '',
  last_login_at: null,
  created_at: null,
  password_change: '',
};
